import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import { GlobalStyle } from "@swegon/sds-core";

import { SdsSetup, SdsWrapper } from "./Sds";

import ApplicationRoutes from "./routes";
import Login from "./pages/Login";
import SignOut from "./pages/SignOut";
import SignedOn from "./pages/SignedOn";
import AuthorizationRoute from "./routes/AuthorizationRoute";

import NotFound from "./pages/NotFound";
import NoAccess from "./pages/NoAccess";
import Projects from "./pages/Projects";

import { getLocationPath } from "./ahu/lib";

const isAhudRedirect = window.location.pathname.endsWith("ahudLite");
if (isAhudRedirect) {
    const ahudLiteQuery = localStorage.getItem("ahudLiteQuery");
    localStorage.removeItem("ahudLiteQuery");
    window.location.href = `${window.location.origin}/ahu${ahudLiteQuery}`;
}

// If it's the latest version served on /ahu, we base the routes on /ahu.
// Otherwise, if it's served on a specific version (e.g. /1.0.123.456)
// we base it on that, fetching the version number from the config
const basename = getLocationPath(window.location.pathname);
const history = createBrowserHistory();

const App = () => (
    <>
        <GlobalStyle />
        <Router basename={basename}>
            <SdsSetup>
                <div className='App'>
                    <SdsWrapper history={history}>
                        <Switch>
                            <Route path='/login' component={Login} />
                            <Route path='/signout' component={SignOut} />
                            <Route exact path='/noAcess' component={NoAccess} />
                            <Route path='/Forbidden' component={NoAccess} />
                            <AuthorizationRoute exact path='/' component={ApplicationRoutes} />
                            <AuthorizationRoute exact path='/projects' component={Projects} />
                            <Route path='/authorized' component={SignedOn} />
                            <Route path='*' component={NotFound} />
                        </Switch>
                    </SdsWrapper>
                </div>
            </SdsSetup>
        </Router>
    </>
);
export default App;
